import React, { useState } from "react";
import { Image, StyleSheet,View, StatusBar } from "react-native";
import { STYLES } from "../../assets/styles";
import { lightenColor } from "../../common";
import CustomIcon from "../../components/CustomIcon";
import Loading from "../../components/Loading";
import SignUP from "../../components/SignUP";

function SignUp({ navigation }) {
  const [loading, setLoading] = useState(false);

  const handleNavigation = ({ route, params = {} }) => {
    navigation.navigate(route, params);
  };

  return (
    <View style={{ flex: 1 }}>
      <Image
        source={require("./../../assets/images/image1.jpg")}
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
        }}
      />
      <View
        style={{
          flex: 1,
          backgroundColor: lightenColor(STYLES.colors.black, "50"),
        }}
      >
        <View
          style={{
            padding: 10,
            paddingTop: StatusBar.currentHeight,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <CustomIcon
            type="AntDesign"
            name="left"
            onPress={() => navigation.goBack()}
            style={{
              fontSize: STYLES.fontSizes.xlarge,
              color: STYLES.colors.white,
            }}
          />
          {/* <CustomButton
            text="skip"
            transparent={true}
            textStyle={{ color: STYLES.colors.white }}
            rightIcon={{ type: "AntDesign", name: "right" }}
            iconStyle={{
              fontSize: STYLES.fontSizes.medium,
              padding: 0,
              color: STYLES.colors.white,
            }}
          /> */}
        </View>
        <View style={styles.container}>
          <SignUP
            onLoadingChange={setLoading}
            onVerifyUser={(user) => {
              handleNavigation({
                route: "verify",
                params: { id: user._id, email: user.email },
              });
            }}
            onSignInPress={() => {
              handleNavigation({ route: "signin" });
            }}
            transparent
          />
        </View>
        {loading ? <Loading spinner /> : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default SignUp;
